import React from 'react';
import { Button, useRecordContext, useNotify } from 'react-admin';
import { ContentCopy } from '@mui/icons-material';
import { Box } from '@mui/material';

// Helper function to get nested property value
const getNestedValue = (obj: any, path: string): any => {
  return path.split('.').reduce((current, key) => current?.[key], obj);
};

const CopyUrlField = ({ source, baseUrl = '', label = 'Copy URL' }: any) => {
  const record = useRecordContext();
  const notify = useNotify();

  if (!record) return null;

  const filePath = getNestedValue(record, source);
  if (!filePath) return null;

  // Construct the full public URL
  const publicUrl = `${baseUrl}/${filePath}`;

  const handleCopy = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation(); // Prevent row click
    try {
      await navigator.clipboard.writeText(publicUrl);
      notify('URL copied to clipboard!', { type: 'success' });
    } catch (err) {
      console.error('Failed to copy URL:', err);
      notify('Failed to copy URL', { type: 'error' });
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Button
        onClick={handleCopy}
        size="small"
        startIcon={<ContentCopy />}
        variant="outlined"
        sx={{ minWidth: 'auto' }}
      >
        <span>Copy</span>
      </Button>
    </Box>
  );
};

export default CopyUrlField;
